import { NavigationStart, Router } from '@angular/router';
import { Component, Input, EventEmitter, Output, OnDestroy, HostListener, ElementRef } from '@angular/core';
import { skip, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NgIf, NgFor, NgClass, LowerCasePipe, DecimalPipe } from '@angular/common';

@Component({
    selector: 'pdp-search-results',
    templateUrl: './search-results.component.html',
    styleUrls: ['./search-results.component.scss'],
    imports: [NgIf, NgFor, NgClass, LowerCasePipe, DecimalPipe]
})
export class SearchResultsComponent implements OnDestroy {

  @Input()
  public searchResults: any;

  @Output()
  public navigatedToResultOutput: EventEmitter<Boolean> = new EventEmitter<Boolean>();
  private unsubscribe: Subject<void> = new Subject();
  constructor(private router: Router, private elementRef: ElementRef) {
    this.router.events
    .pipe(
      // skip(7), 
    takeUntil(this.unsubscribe))
    .subscribe((e) => {
      if (e instanceof NavigationStart) {
        this.navigatedToResultOutput.emit(true);
      }
    });
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event): void {
     if (!this.elementRef.nativeElement.contains(event.target)) {
      // clicked outside => close dropdown list
      if (this.searchResults?.page?.content?.length || this.searchResults?.page?.empty) {
          this.navigatedToResultOutput.emit(true);
      }
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }

  public onClick(item: any) {
    // this.searchResults = null;
    this.navigatedToResultOutput.emit(true);
    this.router.navigate(['/search/itm' + item.product_url], { queryParams: { itm: item.id } });
  }
}
